/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_As_Of_Live_BadgeInputs */

const en_cargos_as_of_live_badge = /** @type {(inputs: Cargos_As_Of_Live_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live`)
};

const es_cargos_as_of_live_badge = /** @type {(inputs: Cargos_As_Of_Live_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En vivo`)
};

/**
* | output |
* | --- |
* | "Live" |
*
* @param {Cargos_As_Of_Live_BadgeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_as_of_live_badge = /** @type {((inputs?: Cargos_As_Of_Live_BadgeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_As_Of_Live_BadgeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_as_of_live_badge(inputs)
	return es_cargos_as_of_live_badge(inputs)
});